import { createColor } from '@manakin/theme/lib/color';

const beautySecondary = createColor('#FFECC2');

export default beautySecondary;
